module.exports = __webpack_public_path__ + "img/haishen.d6c0740d.jpg";